import React, { useEffect, useState } from "react";
import { chairmanApi } from "../../config/api";
import { apiClient, apiFormDataClient } from "../../utils/apiClient";
import "./chairman.scss";

const defaultData = {
  _id: null, Title: "Chairman", Subtitle: "", Name: "", Photo: "", Description: "",
};

const Chairman = () => {
  const [formData, setFormData] = useState(defaultData);
  const [loading, setLoading] = useState(false);
  const [saved, setSaved] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);

  useEffect(() => { fetchData(); }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await apiClient(chairmanApi);
      const result = await response.json();
      if (response.ok && result.data && result.data.length > 0) {
        // Load the record (even if soft-deleted) so we can PUT/restore it
        const record = result.data[0];
        setFormData({
          ...defaultData,
          ...record,
          Title: record.Title || "Chairman",
          Photo: record.Photo || "",
        });
      }
    } catch (error) {
      console.error("Error fetching Chairman data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setSelectedFile(file);
      setPreviewUrl(URL.createObjectURL(file));
    }
  };

  const removePhoto = () => {
    setFormData(p => ({ ...p, Photo: "" }));
    setSelectedFile(null);
    setPreviewUrl(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const method = formData._id ? "PUT" : "POST";
      const url = formData._id ? `${chairmanApi}/${formData._id}` : chairmanApi;
      
      const formDataToSend = new FormData();
      Object.keys(formData).forEach(key => {
        if (key !== 'Photo' && formData[key] !== null) {
          formDataToSend.append(key, formData[key]);
        }
      });

      if (selectedFile) {
        formDataToSend.append('Photo', selectedFile);
      } else if (formData.Photo) {
        formDataToSend.append('Photo', formData.Photo);
      }

      console.log(`[Frontend] Chairman: Submitting ${method} to ${url}`);
      console.log('[Frontend] Chairman: Form Data keys:', Array.from(formDataToSend.keys()));

      const response = await apiFormDataClient(url, {
        method,
        body: formDataToSend,
      });

      console.log(`[Frontend] Chairman: Response Status: ${response.status} ${response.statusText}`);
      const result = await response.json();
      console.log('[Frontend] Chairman: Response Body:', result);

      if (response.ok) {
        setSaved(true);
        setTimeout(() => setSaved(false), 3000);
        fetchData();
        setSelectedFile(null);
        setPreviewUrl(null);
      } else {
        console.error('[Frontend] Chairman: Save failed:', response.status);
      }
    } catch (error) {
      console.error("Error saving Chairman data:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="chairman-page">
      <div className="chairman-page__header">
        <div><h1>Chairman</h1><p>Manage the chairman profile, name, and official message displayed on the institution's portal.</p></div>
        <button className="save-btn" type="submit" form="chairmanForm" disabled={loading}>{loading ? "Saving..." : saved ? "✓ Saved" : "Save Profile"}</button>
      </div>

      <form id="chairmanForm" className="chairman-form" onSubmit={handleSubmit}>
        <div className="chairman-card">
          <div className="form-section-label">Profile Header</div>
          <div className="form-row">
            <div className="form-group"><label>Title</label><input type="text" name="Title" value={formData.Title || ""} onChange={handleChange} placeholder="e.g. Chairman" required /></div>
            <div className="form-group"><label>Subtitle</label><input type="text" name="Subtitle" value={formData.Subtitle || ""} onChange={handleChange} placeholder="e.g. Message to Students" /></div>
          </div>

          <div className="form-section-label">Identity Info</div>
          <div className="form-group">
            <label>Profile Photo</label>
            <div className="photo-upload-box">
              {(previewUrl || formData.Photo) ? (
                <div className="photo-preview-wrapper">
                   <img src={previewUrl || formData.Photo} alt="Preview" className="photo-preview" />
                   <div className="photo-actions">
                      <label className="photo-change-btn">Change Photo<input type="file" accept="image/*" onChange={handleFileChange} style={{ display: 'none' }} /></label>
                      <button type="button" className="photo-remove-btn" onClick={removePhoto}>Remove Photo</button>
                   </div>
                </div>
              ) : (
                <div className="photo-upload-placeholder">
                   <label className="file-upload-label">
                      <div className="upload-icon">📷</div>
                      <span>Click to upload photo</span>
                      <input type="file" accept="image/*" onChange={handleFileChange} style={{ display: 'none' }} />
                   </label>
                </div>
              )}
            </div>
          </div>

          <div className="form-group"><label>Full Name</label><input type="text" name="Name" value={formData.Name || ""} onChange={handleChange} placeholder="Enter full name" required /></div>
          <div className="form-group"><label>Message / Description</label><textarea name="Description" rows="12" value={formData.Description || ""} onChange={handleChange} placeholder="Type the chairman's official message here..." required /></div>
        </div>
      </form>
    </div>
  );
};

export default Chairman;